// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app"; // TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY_FB,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN_FB,
  projectId: "fiduvalor-628ad",
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET_FB,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID_FB,
  appId: process.env.REACT_APP_APP_ID_FB,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID_FB,
};

// Initialize Firebase
export const firebaseApp = firebase.initializeApp(firebaseConfig);
